module.exports = __webpack_public_path__ + "img/logo-full.b90f2dd.png";